export class EventData {
    eventName?: string;
    component: Component;
    payment: Payment;
}

export class Component {
    CategoryEvent?: string;
    LabelEvent?: string;
    ActionEvent?: string;
    LocationEvent?: string;
    EventDetails?: string;
    PositionEvent?: string;
    URLClicked?: string;
    AffordabilityJourney?: string;
    Value?: string;
    AffAgeGroups?: string;
    AffLimitType?: string;
    AffordabilityGroups?: string;
    flowName?: string;
}

export class Payment {
    method?: string;
    txnAmount?: string;
    baseCurrency?: string;
    error?: string;
    source?: string;
    depositMethod?: string;
    Source?: string;
    txnCurrency?: string;
    baseAmount?: string;
    lifeTimeDeposits?: string;
    product?: string;
    amountType?: string;
    depositTransactionId?: string;
}
